import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Main from './Main';
import Create from './Create';
import Update from './Update';

import { getSitemapData } from '../../../utils';

const sitemapValue = 'ADMIN_CONTEST';
const { fullPathname } = getSitemapData(sitemapValue);

function Contest() {
	return (
		<Switch>
			<Route path={fullPathname} exact>
				<Main />
			</Route>

			<Route path={fullPathname + '/create'}>
				<Create />
			</Route>

			<Route path={fullPathname + '/update'}>
				<Update />
			</Route>

			{/* Error handling */}
			<Route>
				<div> 404 Not found</div>
			</Route>
		</Switch>
	);
}

export default Contest;
